module.exports = __webpack_public_path__ + "static/media/lb.8da368bc.svg";